// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__lyB9Z","title":"Info_title__1vTiQ","selects":"Info_selects__37F8z","requiredAsterisk":"Info_requiredAsterisk__kM2fV"};